const mapMixin = {
  methods: {
    async setCoordinates(address) {
      try {
        const addressString = `${address.street1} ${address.city} ${address.state} ${address.zip}`;
        
        const httpClient = this.$http || this.$axios;
        const response = await httpClient.post('/google-places/geocode', {
          address: addressString
        });

        if (response.data && response.data.length > 0) {
          const { location } = response.data[0].geometry;
          return Object.assign(address, {
            lat: location.lat,
            lng: location.lng
          });
        } else {
          this.notificateError('Address is wrong, try again');
          throw new Error('Address is wrong');
        }
      } catch (error) {
        this.notificateError('Address is wrong, try again');
        throw error;
      }
    }
  }
};

export { mapMixin as default };
